import React from 'react'
import { Link } from 'react-router-dom'
import productMap from './productMap'
import { formatZAR } from './utils'

const CartItem = ({ id, quantity, onUpdate, onRemove }) => {
  const product = productMap[id]
  const name = product?.name || id
  const price = product?.price ?? 0
  const image = product?.image || null
  const link = product?.link || null

  const subtotal = price * quantity

  return (
    <div className="flex flex-wrap items-center gap-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-gray-100">
        {image ? (
          <img src={image} alt={name} className="h-full w-full object-contain" />
        ) : (
          <span className="text-xs text-gray-400">No img</span>
        )}
      </div>

      <div className="min-w-0 flex-1">
        {link ? (
          <Link to={link} className="truncate font-semibold text-gray-900 hover:text-violet-500">
            {name}
          </Link>
        ) : (
          <p className="truncate font-semibold text-gray-900">{name}</p>
        )}
        <p className="mt-1 text-sm text-gray-500">{formatZAR(price)} each</p>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => quantity <= 1 ? onRemove(id) : onUpdate(id, quantity - 1)}
          className="flex h-8 w-8 items-center justify-center rounded border border-gray-300 bg-gray-50 text-sm font-medium text-gray-700 hover:bg-gray-100"
        >
          −
        </button>
        <span className="w-8 text-center text-sm font-medium text-gray-900">
          {quantity}
        </span>
        <button
          onClick={() => onUpdate(id, quantity + 1)}
          className="flex h-8 w-8 items-center justify-center rounded border border-gray-300 bg-gray-50 text-sm font-medium text-gray-700 hover:bg-gray-100"
        >
          +
        </button>
      </div>

      <p className="w-24 text-right font-semibold text-gray-900">
        {formatZAR(subtotal)}
      </p>

      <button
        onClick={() => onRemove(id)}
        className="flex h-8 w-8 items-center justify-center rounded-full text-gray-400 hover:bg-red-50 hover:text-red-600"
        title="Remove item"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>
    </div>
  )
}

export default CartItem
